import React, {CSSProperties} from 'react'
import styles from './AnimatedWaitIcon.module.scss'
import clsx from 'clsx'

type AnimatedWaitIconAnimationType = 'fade' | 'bounce'

export interface AnimatedWaitIconProps {
    className?: string
    animationType: AnimatedWaitIconAnimationType
    size?: 'small' | 'default' | 'large'
    color?: CSSProperties['color']
}

export function AnimatedWaitIcon({className, animationType, size = 'default', color}: AnimatedWaitIconProps) {
    const style = color !== undefined ? {'--dot-color': color} as React.CSSProperties : undefined
    return (
        <div className={clsx(styles.ellipsis, styles[animationType], styles[size], className)} style={style}>
            <div className={styles.dot}></div>
            <div className={styles.dot}></div>
            <div className={styles.dot}></div>
        </div>
    )
}
